module.exports = __webpack_public_path__ + "src/app/assets/images/speakers/bernhardt.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/speakers/bernhardt.jpg
// module id = 612
// module chunks = 0